// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application";
import DropzoneController from "./dropzone_controller";
import RendererController from "./renderer_controller";
import GroupInputsController from "./group_inputs_controller";
import DateRangeController from "./date_range_controller";
import InlineEditorController from "./inline_editor_controller";
import InlineEditorFormController from "./inline_editor_form_controller";
import IbanController from "./iban_controller";
import AdjustImagesController from "./adjust_images_controller";

application.register("dropzone", DropzoneController);
application.register("renderer", RendererController);
application.register("groupInputs", GroupInputsController);
application.register("dateRange", DateRangeController);
application.register("inlineEditor", InlineEditorController);
application.register("inlineEditorForm", InlineEditorFormController);
application.register("iban", IbanController);
application.register("adjustImages", AdjustImagesController);